import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from "../../../pages/com.usblick.common/auth/auth.service";
import { UsblickCommonEnum } from '../../../pages/com.usblick.common/usblick-common-enum';
import { setting } from "../../../../../setting";
import CssFilterConverter from 'css-filter-converter';


@Component({
  selector: 'usb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() clientsSettings: any;
  @ViewChildren('iconSocialNetworks', { read: ElementRef }) iconSocialNetworks : QueryList<ElementRef>;

  menuHidden = true;
  public getClientsSettingAppBooking: any;
  public sectionFooter: any;
  public routeUploadFile:any;
  isHome: boolean = true;
  currentYear: any;
  public wsp_number: string;
  filter: any;

  constructor(
    private router: Router,
    private authenticationService: AuthService) {


    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/home')) {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      }
    });
  }

  ngOnInit() {
    this.routeUploadFile =  setting.routeUploadFile;
    this.clientData();
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.applyImageFilter();
  }

  clientData(): void {
    this.getClientsSettingAppBooking = this.clientsSettings;

    let wspNumber = this.getClientsSettingAppBooking?.wsp_phone_number;

    // Eliminar el signo + y los espacios en blanco
    wspNumber = wspNumber.replace(/\+/g, '').replace(/\s/g, '');

    this.wsp_number = wspNumber;

    this.sectionFooter = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_footer);

  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }
  setLanguage(language: string) {
  }

  logout() {
    this.authenticationService.logout({
      _token : this.authenticationService.getCookie(UsblickCommonEnum.cookieName)
    })
      .subscribe(() => this.router.navigate(['/login'], { replaceUrl: true }));
  }

  itinerary(){
    this.router.navigate(['itinerary']);
  }
  get username(): string {
    const name = "NmbrrePrueba";
    return name ? name : null;
  }

    onLinkAbout(fragment: string) {
    const typeArticle = 'aboutUs'; // Aquí puedes configurar la variable small como necesites
    const id = 17; // Usar el índice o el id que se pase como parámetro
    const active = 0
    this.router.navigate([`/article/${typeArticle}/${id}/${this.getClientsSettingAppBooking.id}/${active}`], { fragment }).then(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'});
    });
  }

  articleRedirect(index): void {
    const typeArticle = 'segment'; // Aquí puedes configurar la variable small como necesites
    const id = index; // Usar el índice o el id que se pase como parámetro
    const active = 0
    this.router.navigate([`/article/${typeArticle}/${id}/${this.getClientsSettingAppBooking.id}/${active}`]).then(() => {
      window.scrollTo({
        top: 0,
        left: 0,  
        behavior: 'smooth'});
    });;
  }

      // Aplica un filtro de css al elemento de imagen utilizando el color seteado por cliente.
    applyImageFilter() {
      const color = this.sectionFooter.color_icon;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      const filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {
        this.iconSocialNetworks.forEach(icon => {
          icon.nativeElement.setAttribute('style', `filter: ${filter}`);
        });
      }, 100);
    }

  onLinkSegment(nameRoute: string) {

    if(nameRoute === 'leisure') {
      this.router.navigate(['/leisure']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'wellnes') {
      this.router.navigate(['/wellnes']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'luxury') {
      this.router.navigate(['/luxury']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'mice') {
      this.router.navigate(['/mice']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'sports') {
      this.router.navigate(['/sports']).then(() => {
        window.scrollTo(0, 0);
      })
    }
    if(nameRoute === 'corporative') {
      this.router.navigate(['/corporative']).then(() => {
        window.scrollTo(0, 0);
      })
    }


  }

  /**
* Método para redirigir a una página de gestión específica según la opción proporcionada.
*
* Este método redirige al usuario a una ruta de gestión específica basada en la opción proporcionada.
*
* @mannagementOption-> Opción de gestión que define a qué ruta se debe redirigir al usuario.
*/
mannagementRedirect(mannagementOption: any, typeOption: number) {
  switch(typeOption) {
    case 1:
      this.router.navigate([`mannagement/${mannagementOption}`]);
      break;
    case 2:
      this.router.navigate([`shortCutsMannager/${mannagementOption}`]);
      break;
  }

}
}
